import classNames from 'classnames';
import React, { useState } from 'react';

import SmallProfileDisplayItem, { DisplayProps } from './SmallProfileDisplayItem';

const styles = require('./SmallProfileDisplayList.module.scss');

interface Props {
  color: string;
  skills: DisplayProps[];
}

export default function SmallProfileDisplayList(props: Props) {
  const { skills } = props;
  return (
    <div className={styles.skillList}>
      {skills.map((skill, index) => (
        <SmallProfileDisplayItem
          color={props.color}
          {...skill}
          key={skill.title}
        />
      ))}
    </div>
  );
}
